export const batchesStates = {
  1: { label: 'Creado', color: 'secondary', icon: 'SearchIcon' },
  2: { label: 'Borrador', color: 'secondary', icon: 'SearchIcon' },
  3: { label: 'En revisión', color: 'warning', icon: 'SearchIcon' },
  4: { label: 'Rechazado', color: 'danger', icon: 'SearchIcon' },
  5: { label: 'Anulado', color: 'danger', icon: 'SearchIcon' },
  6: { label: 'Aprobado', color: 'primary', icon: 'SearchIcon' },
  7: { label: 'Disponible', color: 'primary', icon: 'FileTextIcon' },
  8: { label: 'Catalogado', color: 'success', icon: 'ArchiveIcon' },
  9: { label: 'Completado', color: 'success', icon: 'SearchIcon' },
  10: { label: 'Publicado', color: 'success', icon: 'SearchIcon' },
  11: { label: 'Adjudicado', color: 'success', icon: 'SearchIcon' },
  12: { label: 'Devuelto', color: 'warning', icon: 'SearchIcon' },
  13: { label: 'Facturado', color: 'info', icon: 'SearchIcon' },
  14: { label: 'Rescatado', color: 'light-danger', icon: 'SearchIcon' },
  15: { label: 'Donado', color: 'info', icon: 'ArchiveIcon' },
  16: { label: 'Destruído', color: 'light-danger', icon: 'TrashIcon' },
};

export const batchesCodeSates = {
  creado: 1,
  borrador: 2,
  revision: 3,
  rechazado: 4,
  anulado: 5,
  aprobado: 6,
  disponible: 7,
  catalogado: 8,
  completado: 9,
  publicado: 10,
  adjudicado: 11,
  devuelto: 12,
  facturado: 13,
  rescatado: 14,
  donado: 15,
  destruido: 16
};

export const batchesActionStates = {
  VALIDAR: 'validar',
  DONAR: 'donar',
  DESTRUIR: 'destruir'
};

export const CANCEL_STATES = [
  batchesCodeSates.creado,
  batchesCodeSates.rechazado,
  batchesCodeSates.borrador,
  batchesCodeSates.disponible
];
export const RETURN_STATES = [
  batchesCodeSates.publicado,
  batchesCodeSates.facturado
];
export const REJECT_STATES = [batchesCodeSates.revision];
export const VALIDATE_STATES = [batchesCodeSates.creado];
export const APPROVE_STATES = [batchesCodeSates.revision];
export const POSTULE_STATES = [batchesCodeSates.disponible];
export const RESCUE_STATES = [
  batchesCodeSates.creado,
  batchesCodeSates.revision,
  batchesCodeSates.aprobado,
  batchesCodeSates.disponible,
  batchesCodeSates.catalogado,
  batchesCodeSates.publicado
];
export const EDIT_STATES = [
  batchesCodeSates.creado,
  batchesCodeSates.borrador,
  batchesCodeSates.rechazado,
  batchesCodeSates.aprobado,
  batchesCodeSates.disponible,
  batchesCodeSates.catalogado,
  batchesCodeSates.devuelto
];
export const NO_APPROVAL_REQUIRED = 0;
export const YES_APPROVAL_REQUIRED = 1;

export const IS_NOT_EXISTING_BATCH = 2;
export const IS_EXISTING_BATCH = 1;
